<h5 class="mt-3">{{ 'externalEmployees.masterData.shiftReadiness.title' | baseBusinessKey | translate }}</h5>
<div class="py-3">
  <div
    *ngFor="let shift of shifts"
    class="row py-2"
  >
    <div class="col-3">
      <span class="fw-bold">
        <i class="fa-regular fs-5 me-2 {{ baseShiftIconsEnum[shift] }}"></i>
        {{ 'externalEmployees.masterData.shiftReadiness.' + shift | baseBusinessKey | translate }}
      </span>
    </div>
    <div class="col-9 d-flex align-items-center">
      <base-checkbox
        [isChecked]="!!profile?.candidateAvailability?.[shift]"
        [isDisabled]="true"
      ></base-checkbox>
    </div>
  </div>
  <div class="row align-items-center py-2">
    <div class="col-3">
      <span class="fw-bold">
        <i class="fa-solid fa-calendar-week fs-5 me-2"></i>
        {{ 'externalEmployees.masterData.shiftReadiness.weekdays' | translate }}
      </span>
    </div>
    <div
      *ngIf="profile"
      class="col-9 d-flex gap-2"
    >
      <ng-container *ngFor="let weekday of weekdaysArray">
        <div
          class="label"
          [ngbTooltip]="'tooltip.weekDays.' + weekday[0] | translate"
          [ngClass]="{ active: !!profile.candidateAvailability?.[weekday[1]] }"
        >
          <span>{{ 'weekDays.' + weekday[0] | translate }}</span>
        </div>
      </ng-container>
      <div
        class="label"
        [ngbTooltip]="'days.publicHoliday' | translate"
        [ngClass]="{ active: !!profile.candidateAvailability?.hol }"
      >
        <i class="fa-solid fa-party-horn"></i>
      </div>
    </div>
  </div>
</div>
